import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const sunrunIntegrationErrorTypeValues = ["REPORT_INGEST_WRITE_FAILED"] as const;
const sunrunIntegrationErrorTypeSchema = z.enum(sunrunIntegrationErrorTypeValues);
const SunrunIntegrationErrorType = sunrunIntegrationErrorTypeSchema.enum;
type SunrunIntegrationErrorType = z.infer<typeof sunrunIntegrationErrorTypeSchema>;

export type SunrunIntegrationErrors = {
  errorType: typeof SunrunIntegrationErrorType.REPORT_INGEST_WRITE_FAILED;
  data: { reportType: string; errorName: string; errorCode: string | undefined };
};

export const sunrunIntegrationErrorDetails: Record<SunrunIntegrationErrorType, ErrorDetails> = {
  [SunrunIntegrationErrorType.REPORT_INGEST_WRITE_FAILED]: {
    sentryDescription: "Sunrun report rows could not be written to the integration database",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
};
